module.exports = "/_next/static/images/tt-9574aff3e3c49324a07d2e4f116475e1.svg";